module.exports = __webpack_public_path__ + "img/report-default.b9b4f962.svg";